// extracted by mini-css-extract-plugin
export default {"item":"_tSZMRGJTodgfko0MNPJ"};